//Plan type and rebate program
export const GET_PLAN_TYPE_DATA = 'GET_PLAN_TYPE_DATA';
export const GET_REBATE_PROGRAM_NDC_DETAILS = 'GET_REBATE_PROGRAM_NDC_DETAILS';
export const GET_ERROR_MSG_NDC_DETAILS = 'GET_ERROR_MSG_NDC_DETAILS';
export const HANDLE_ERROR_MESSAGE_FOR_G_INV = 'HANDLE_ERROR_MESSAGE_FOR_G_INV';
export const SET_SELECTED_INPUT_NDC_DETAILS = 'SET_SELECTED_INPUT_NDC_DETAILS';
export const SET_NDC_DETAILS_REPORT_DATA = 'SET_NDC_DETAILS_REPORT_DATA';
export const REFRESH_NDC_DETAILS = 'REFRESH_NDC_DETAILS';
export const REFRESH_NDC_DETAILS_DISPLAY = 'REFRESH_NDC_DETAILS_DISPLAY';
export const IS_LOADING = 'IS_LOADING';
export const SET_NDC_DETAIL_REPORT_DATA_ALL = 'SET_NDC_DETAIL_REPORT_DATA_ALL';
export const SET_PAGINATION_INDEX_NDC_DETAILS =
  'SET_PAGINATION_INDEX_NDC_DETAILS';
export const SET_NDC_REPORT_DATA_AVAIL = 'SET_NDC_REPORT_DATA_AVAIL';
export const NDC_SELECT_TYPE = 'NDC_SELECT_TYPE';